import { faBadgePercent as badgePercent } from '@fortawesome/pro-regular-svg-icons/faBadgePercent';
import { faBarsProgress as barsProgress } from '@fortawesome/pro-regular-svg-icons/faBarsProgress';
import { faBookOpen as bookOpen } from '@fortawesome/pro-regular-svg-icons/faBookOpen';
import { faBookUser as bookUser } from '@fortawesome/pro-regular-svg-icons/faBookUser';
import { faBrowser as browser } from '@fortawesome/pro-regular-svg-icons/faBrowser';
import { faBullhorn as bullhorn } from '@fortawesome/pro-regular-svg-icons/faBullhorn';
import { faCoins as coins } from '@fortawesome/pro-regular-svg-icons/faCoins';
import { faEnvelope as envelope } from '@fortawesome/pro-regular-svg-icons/faEnvelope';
import { faFiles as files } from '@fortawesome/pro-regular-svg-icons/faFiles';
import { faGear as gear } from '@fortawesome/pro-regular-svg-icons/faGear';
import { faLanguage as language } from '@fortawesome/pro-regular-svg-icons/faLanguage';
import { faLock as lock } from '@fortawesome/pro-regular-svg-icons/faLock';
import { faMessageLines as messageLines } from '@fortawesome/pro-regular-svg-icons/faMessageLines';
import { faMessages as messages } from '@fortawesome/pro-regular-svg-icons/faMessages';
import { faMoneyBill as moneyBill } from '@fortawesome/pro-regular-svg-icons/faMoneyBill';
import { faNote as note } from '@fortawesome/pro-regular-svg-icons/faNote';
import { faRetweet as retweet } from '@fortawesome/pro-regular-svg-icons/faRetweet';
import { faShieldCheck as shieldCheck } from '@fortawesome/pro-regular-svg-icons/faShieldCheck';
import { faSquareQuestion as squareQuestion } from '@fortawesome/pro-regular-svg-icons/faSquareQuestion';
import { faUsers as users } from '@fortawesome/pro-regular-svg-icons/faUsers';

const icons = {
  badgePercent,
  barsProgress,
  bookOpen,
  bookUser,
  browser,
  bullhorn,
  coins,
  envelope,
  files,
  gear,
  language,
  lock,
  messageLines,
  messages,
  moneyBill,
  note,
  retweet,
  shieldCheck,
  squareQuestion,
  users,
};

export default icons;
